import {route} from "@lernetz/ts-lib";
import {Gateway} from "@lernetz/ts-lib/src/Gateway";
import {languageService} from "../services/lang";
import {Infobox} from "./components/article/infobox.component";
import {Quote} from "./components/article/quote.component";
import {RawHtml} from "../components/article-elements/rawhtml/RawHtml";



export class GoodPracticeGateway extends Gateway {
    routeBase = "api.goodPractices";
    constructor(config) {
        super(config);
        this.in.add('App\\GoodPractice', dto => {
            const date = new Date(dto.date.split(' ')[0]);
            const locale = languageService.currentLang === 'en' ? 'en-US' : 'de-CH';
            const formattedDate = date.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric'});
            dto.date = formattedDate;
            return dto;
        });
        this.in.add('App\\Quote', dto => new Quote(dto));
        this.in.add('App\\Infobox', dto => new Infobox(dto));
        this.in.add( "App\\RawHtml", ( dto ) => new RawHtml( dto ) );
    }
    async find() {
        const goodPractices = await route(this.routeBase).load();
        return this.in.transform(goodPractices);
    }
    async get(id) {
        const goodPractices = await route(`${this.routeBase}.details`, { good_practice: id}).load();
        return this.in.transform(goodPractices);
    }
}
